import { Smartphone } from 'lucide-react'

import { usePwaInstall } from '../../hooks/usePwaInstall'
import PwaInstallButton from './PwaInstallButton'

// Banner de instalación mobile-first. Se muestra solo en móvil/tablet,
// si la PWA es instalable, no está instalada, y el usuario no lo
// descartó en los últimos 7 días ("Ahora no"). El botón manual
// "Instalar aplicación" del menú (ver AppLayout) no depende de este
// cooldown. En desktop no se muestra nunca, ni siquiera se consulta el
// cooldown.
function PwaInstallPrompt() {
  const {
    instalado,
    isMobileDevice,
    puedeInstalar,
    cooldownActivo,
    posponer,
  } = usePwaInstall()

  if (!isMobileDevice) return null
  if (instalado || !puedeInstalar || cooldownActivo) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 p-3 sm:flex sm:justify-center sm:p-4">
      <div className="mx-auto flex w-full max-w-md flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-xl sm:flex-row sm:items-center sm:gap-4">
        <div className="flex items-start gap-3 sm:flex-1">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
            <Smartphone size={22} />
          </span>

          <div className="min-w-0">
            <p className="font-bold text-slate-900">
              Instala Franco Frutt
            </p>
            <p className="mt-0.5 text-sm text-slate-500">
              Accede más rápido desde tu pantalla de inicio.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-2 sm:w-auto sm:shrink-0 sm:flex-row">
          <PwaInstallButton
            iconSize={18}
            className="flex min-h-[44px] w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-emerald-700 sm:w-auto"
          />

          <button
            type="button"
            onClick={posponer}
            className="min-h-[44px] w-full rounded-lg border border-slate-300 px-4 py-2.5 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 sm:w-auto"
          >
            Ahora no
          </button>
        </div>
      </div>
    </div>
  )
}

export default PwaInstallPrompt
